import { render, staticRenderFns } from "./base-spinner.vue?vue&type=template&id=0b158c72"
import script from "./base-spinner.vue?vue&type=script&lang=js"
export * from "./base-spinner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports